var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.404 17.5l5.77-3.346a2.096 2.096 0 012.307 0L17.25 17.5V3.308c0-.693-.462-1.154-1.154-1.154H4.558c-.693 0-1.154.461-1.154 1.154V17.5zM4.558 1h11.538a2.314 2.314 0 012.308 2.308v15.115c0 .346-.23.577-.577.577-.115 0-.23 0-.23-.115l-6.693-3.808a1.048 1.048 0 00-1.154 0l-6.692 3.808a.608.608 0 01-.808-.231V3.308A2.314 2.314 0 014.558 1z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.475 5.224l.908 1.932 2.082.221-1.392 1.59.396 2.174-1.994-1.022-1.993 1.022.395-2.174-1.392-1.59 2.082-.221.908-1.932z",
    stroke: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect);
export default __webpack_public_path__ + "static/assets/collect.b04f73de.svg";
export { ForwardRef as ReactComponent };